import $ from 'jquery';

// Map slider values (0-5) to multipliers
const multipliers = [1, 5, 10, 15, 20, 25];

// Update the style and data attributes when slider value changes
$('.range').on('input', function () {
	const sliderValue = +this.value;

	// Map sliderValue (0-5) to the desired multiplier
	const multiplier = multipliers[sliderValue] || 1; // Default to 1 if sliderValue is null or invalid

	// Update the slider's style and data attributes
	const percentage = (sliderValue / 5) * 100;
	this.setAttribute('style', `--w:${percentage}%`);
	this.setAttribute('data-w', multiplier);

	// Update prices based on the multiplier
	updatePrices(multiplier);
	updateYears(multiplier);
});

// Initialize checkboxes and their functionality
const checkboxes = document.querySelectorAll('.combine__checked input[type="checkbox"]');
const investmentElement = document.querySelector('span[data-type="investment"]');
const savingElements = document.querySelectorAll('span[data-type="saving"]');
const co2Element = document.querySelector('span[data-type="co2"]');
const yearElement = document.querySelector('span[data-year="year"]');

// Helper function to format numbers with periods as thousand separators and no decimals
function formatNumber(number) {
	return number.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); // Format with periods as thousand separators
}

// Function to animate number change
function animateValue(element, start, end, duration) {
	const startTime = performance.now();

	function update(time) {
		// Calculate the elapsed time
		const elapsed = (time - startTime) / duration;
		// Calculate the current value
		const progress = Math.min(elapsed, 1);
		const value = Math.round(start + (end - start) * progress);

		// Update the element's text content
		element.textContent = `${formatNumber(value)}`;

		// Continue the animation if not finished
		if (progress < 1) {
			requestAnimationFrame(update);
		}
	}

	requestAnimationFrame(update);
}

// Function to update prices based on the current multiplier
function updatePrices(multiplier) {
	let totalInvestment = 0;
	let totalSaving = 0;
	let totalCo2 = 0;

	checkboxes.forEach(checkbox => {
		if (checkbox.checked) {
			// Investment remains unaffected
			totalInvestment += parseFloat(checkbox.getAttribute('data-investing'));

			// Apply multiplier to saving and CO2
			totalSaving += parseFloat(checkbox.getAttribute('data-saving')) * (multiplier || 1);
			totalCo2 += parseFloat(checkbox.getAttribute('data-co2')) * (multiplier || 1);
		}
	});

	// Animate changes
	if (investmentElement) {
		animateValue(investmentElement, parseFloat(investmentElement.textContent.replace('.', '').replace(/\s/g, '')), totalInvestment, 1000);
	}
	if (savingElements) {
		savingElements.forEach((savingElement) => {
			animateValue(savingElement, parseFloat(savingElement.textContent.replace('.', '').replace(/\s/g, '')), totalSaving, 1000);
		});
	}
	if (co2Element) {
		const currentCo2Value = parseFloat(co2Element.textContent.replace('.', '').replace(/\s/g, ''));
		animateValue(co2Element, currentCo2Value || 1, totalCo2, 1000);
	}
}

function updateYears(multiplier) {
	const years = multiplier;

	if (yearElement) {
		yearElement.textContent = years;

		const elements = document.querySelectorAll('.text[data-text-year]');
		elements.forEach(el => {
			el.style.opacity = 0;
			el.style.visibility = 'hidden';
			el.style.height = 0;
		});

		const element = document.querySelector(`.text[data-text-year="${years}"]`);
		if (element) {
			element.style.opacity = 1;
			element.style.visibility = 'visible';
			element.style.height = 'auto';
		}
	}
}


// Ensure at least one checkbox is checked
function ensureMinimumSelection(event) {
	const checkedCount = Array.from(checkboxes).filter(checkbox => checkbox.checked).length;

	// If there is only one checkbox checked and the user attempts to uncheck it
	if (checkedCount === 0 && !event.target.checked) {
		event.preventDefault(); // Prevent unchecking
		event.target.checked = true; // Re-check the checkbox
		return false; // Exit the function
	}

	// Hide or show <i> elements based on the number of checked checkboxes
	checkboxes.forEach(checkbox => {
		const iconElement = checkbox.parentElement.querySelector('i');
		if (iconElement) {
			if (checkbox.checked && checkedCount > 1) {
				iconElement.style.display = 'block';
			} else {
				iconElement.style.display = 'none';
			}
		}
	});

	// Update prices only if checkbox state changes successfully
	const sliderValue = +$('.range').val(); // Get the current slider value (0-5)
	const multiplier = multipliers[sliderValue] || 1; // Map to the correct multiplier

	updatePrices(multiplier);
	updateYears(multiplier);
}


checkboxes.forEach(checkbox => {
	checkbox.addEventListener('change', ensureMinimumSelection);
});

// Initialize with default values
updatePrices(1); // Default multiplier is 1
updateYears(1);
